export const ACCOUNTS_PAYABLE_PERMISSION_MODULE = 'AccountsPayable';

/**
 * Frontend permission keys used in UI/guards.
 * Some differ from BE action names — see accounts-payable-action-permission.util.
 */
export const AccountsPayableAction = {
  Create: 'Create',
  View: 'View',
  DeleteDraft: 'DeleteDraft',
  Withdraw: 'Withdraw',
  EditDraftOrReturned: 'EditDraftOrReturned',
  EditApprovedOrPaymentPending: 'EditApprovedOrPaymentPending',
  Update: 'Update',
  Duplicate: 'Duplicate',
  Return: 'Return',
  Approve: 'Approve',
  Reject: 'Reject',
  MakePayment: 'MakePayment',
  EditPayment: 'EditPayment',
  ReferToCompanyAdmin: 'ReferToCompanyAdmin',
  CollatedPayment: 'CollatedPayment',
  BillEdit: 'BillEdit',
  BillCreate: 'BillCreate',
  IntegrateToNetSuite: 'IntegrateToNetSuite',
  Restore: 'Restore',
} as const;

export type AccountsPayableActionName =
  (typeof AccountsPayableAction)[keyof typeof AccountsPayableAction];

/** Raw action names returned by /my → companyPermissions.actionPermissions */
export const AccountsPayableBackendAction = {
  Create: 'Create',
  CreateDraft: 'CreateDraft',
  Update: 'Update',
  UpdateDraft: 'UpdateDraft',
  EditReturned: 'EditReturned',
  EditDraftOrReturned: 'EditDraftOrReturned',
  EditApprovedOrPaymentPending: 'EditApprovedOrPaymentPending',
  DeleteDraft: 'DeleteDraft',
  Withdraw: 'Withdraw',
  Duplicate: 'Duplicate',
  Approve: 'Approve',
  Reject: 'Reject',
  Return: 'Return',
  MakePayment: 'MakePayment',
  EditPayment: 'EditPayment',
  Refer: 'Refer',
  ReferToCompanyAdmin: 'ReferToCompanyAdmin',
  CollatedPayment: 'CollatedPayment',
  BillEdit: 'BillEdit',
  BillCreate: 'BillCreate',
  IntegrateToNetSuite: 'IntegrateToNetSuite',
  /** Legacy alias — prefer IntegrateToNetSuite */
  IntegrateNetSuite: 'IntegrateNetSuite',
  Restore: 'Restore',
  View: 'View',
} as const;
